import _each from 'lodash/each'
import _get from 'lodash/get'
import _isArray from 'lodash/isArray'
import _isEqual from 'lodash/isEqual'
import _isFunction from 'lodash/isFunction'
import _isObject from 'lodash/isObject'
import _map from 'lodash/map'
import _set from 'lodash/set'
import _transform from 'lodash/transform'
import _unset from 'lodash/unset'

export function evaluate(o, context = null) {
  return _isFunction(o)
    ? o.call(context, context, ...(arguments.length ? Array.from(arguments).slice(2) : {}))
    : o
}

export function modelsDiffer(modelA, modelB, keysIgnoredForComparison = []) {
  // console.log(objectDifference(modelA, modelB, keysIgnoredForComparison));
  return objectsDiffer(modelA, modelB, keysIgnoredForComparison)
}

export function objectsDiffer(objA, objB, keysIgnoredForComparison = []) {
  let a = deepOmit(objA || {}, keysIgnoredForComparison)
  let b = deepOmit(objB || {}, keysIgnoredForComparison)
  let isEqual = _isEqual(a, b)
  return !isEqual
}

export function objectDifference(object, base, keysIgnoredForComparison = []) {
  let a = deepOmit(object || {}, keysIgnoredForComparison)
  let b = deepOmit(base || {}, keysIgnoredForComparison)

  function changes(obj, baseObj) {
    return _transform(obj, function (result, value, key) {
      if (!_isEqual(value, baseObj[key])) {
        result[key] =
          _isObject(value) && _isObject(baseObj[key]) ? changes(value, baseObj[key]) : value
      }
    })
  }

  return changes(a, b)
}

export function deepOmit(obj, omitPaths = []) {
  let object = { ...obj }
  _each(omitPaths, path => {
    let pathParts = path.split('.')
    let finalPart = pathParts.pop()
    let firstPart = pathParts.join('.') || ''
    let currentTopValue = _get(object, firstPart)
    if (firstPart && _isArray(currentTopValue)) {
      _set(
        object,
        firstPart,
        _map(currentTopValue.slice(0), e => {
          return _unset(e, finalPart)
        })
      )
    } else {
      _unset(object, path)
    }
  })
  return object
}
